// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-FRzC7";
var _3 = "review-L6eZ3";
var _4 = "icon-TiCpB";
var _5 = "account--lRFx";
var _6 = "buttons-yvrhy";
export { _1 as "__esModule", _2 as "root", _3 as "review", _4 as "icon", _5 as "account", _6 as "buttons" }
export default { "__esModule": _1, "root": _2, "review": _3, "icon": _4, "account": _5, "buttons": _6 }
